import styles from './FilterBar.module.css';

export interface FilterBarProps<T extends string> {
  readonly options: readonly T[];
  readonly value: T;
  readonly onChange: (value: T) => void;
  readonly label: string;
  readonly compact?: boolean | undefined;
}

/**
 * A row of mutually exclusive text filters.
 *
 * Each option is a toggle button carrying `aria-pressed`, which announces the
 * current selection without the visual weight of a radio group.
 */
export function FilterBar<T extends string>({
  options,
  value,
  onChange,
  label,
  compact,
}: FilterBarProps<T>) {
  return (
    <div
      className={`${styles.bar} ${compact ? styles.compact : ''}`}
      role="group"
      aria-label={label}
    >
      {options.map((option) => (
        <button
          key={option}
          type="button"
          className={styles.option}
          aria-pressed={option === value}
          onClick={() => onChange(option)}
        >
          {option}
        </button>
      ))}
    </div>
  );
}
